// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Feeds/index.css
// module id = 2498
// module chunks = 0